import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  standalone: true,
  name: 'fileSize',
})
export class FileSizePipe implements PipeTransform {
  private kilobyte_text: string = "kb";
  private megabyte_text: string = "mb";
  private gigabyte_text: string = "gb";
  private kilobyte: number = 1024;
  private megabyte: number = 1024 * 1024;
  private gigabyte: number = 1024 * 1024 * 1024;
  transform(value: number): string {
    let finalValue: number = 0;
    let abbreviationText: string = "";
    if (value > this.gigabyte) {
      finalValue = value / this.gigabyte;
      abbreviationText = this.gigabyte_text;
    } else if (value > this.megabyte) {
      finalValue = value / this.megabyte;
      abbreviationText = this.megabyte_text;
    } else if (value > this.kilobyte) {
      finalValue = value / this.kilobyte;
      abbreviationText = this.kilobyte_text;
    }

    let finalValueString: string = finalValue.toFixed(1);
    if (abbreviationText) {
      finalValueString += " " + abbreviationText;
    }
    return finalValueString;
  }
}

